// i18n
import { useTranslation } from 'react-i18next';

// router
import { Link as RouterLink } from 'react-router-dom';

// mui
import { Box, Grid, Link, Paper, Typography } from '@mui/material';

// icons
import {
	DashboardOutlined as IconDashboard,
	FolderOutlined as IconFolder,
	NewReleasesOutlined as IconNewFeatures,
	SupportOutlined as IconSupport,
} from '@mui/icons-material';

// links
import { LinkLearning } from '../../../links/LinkLearning/LinkLearning';

interface QuickLink {
	icon: React.ReactNode;
	label?: string;
	to?: string;
	component?: React.ReactNode;
}

export const Links = () => {
	// hooks
	const { t } = useTranslation();

	const links: QuickLink[] = [
		{ icon: <IconNewFeatures fontSize="small" />, label: t('newFeatures'), to: '/features' },
		{ icon: <IconDashboard fontSize="small" />, label: t('dashboard'), to: '/dashboard' },
		{ icon: <IconFolder fontSize="small" />, label: t('projects'), to: '/projects' },
		{ icon: <IconSupport fontSize="small" />, component: <LinkLearning color="primary" /> },
	];

	return (
		<Paper sx={{ height: '100%', width: '100%' }}>
			<Box sx={(theme) => ({ padding: theme.spacing(2) })}>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<Typography fontWeight={700}>{t('quickLinks')}</Typography>
					</Grid>
					<Grid item xs={12}>
						<Grid container spacing={2}>
							{links.map((link, i) => {
								let content = null;
								if (link.component) {
									content = link.component;
								} else if (link.to && link.label) {
									content = (
										<Link component={RouterLink} to={link.to} underline="hover" variant="body2">
											{link.label}
										</Link>
									);
								}
								return (
									<Grid alignItems="center" container item key={`link-${i}`} spacing={1} xs={12}>
										<Grid item xs="auto">
											{link.icon}
										</Grid>
										<Grid item xs={true}>
											{content}
										</Grid>
									</Grid>
								);
							})}
						</Grid>
					</Grid>
				</Grid>
			</Box>
		</Paper>
	);
};
